module.exports = __webpack_public_path__ + "img/testBNB.07c11f52.svg";